import Security from './security/SecuritySettings';
import User from "./user/UserSettings";
import Support from './support'

export default { User, Security, Support };
